import { Button, Cross, FileIcon, TextBlock } from '../../atoms';
import React from 'react';
import useStyles from './ChosenFileModal.styles';

interface IChosenFileModalProps {
  open?: boolean;
  text?: string;
  buttonText: string;
  buttonSize?: 'small' | 'medium' | 'large';
  handleButtonClick: () => void;
  handleClose: () => void;
  iconType: 'delete' | 'upload';
}

const ChosenFileModal: React.FC<IChosenFileModalProps> = ({
  open,
  text = 'File Name',
  buttonText,
  buttonSize,
  handleButtonClick,
  handleClose,
  iconType,
}) => {
  const classes = useStyles();

  const getIcon = () => {
    if (iconType === 'delete') {
      return <FileIcon iconType="deleteIcon" />;
    } else if (iconType === 'upload') {
      return <FileIcon iconType="deleteIcon" />;
    }
    return null;
  };

  const handleModalClose = () => {
    handleClose();
  };

  return (
    <>
      {open && (
        <div className={classes.root}>
          <div className={classes.closeButton}>
            <Cross onClick={handleModalClose} />
          </div>
          <div className={classes.iconContainer}>{getIcon()}</div>
          <div className={classes.textContainer}>
            <TextBlock type="textErrorModalTB" text={text} />
          </div>
          <div className={classes.buttonContainer}>
            <Button onAction={handleButtonClick} color="blue" size={buttonSize}>
              {buttonText}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default ChosenFileModal;
